// One colour per call status on every screen (TZ 15.1), taken from the approved
// dispatcher prototype (docs/mockups/dispatcher_prototype.html).

import type { Schemas } from '@/api/client';

export type CallStatus = Schemas['CallStatus'];

export const CALL_STATUS_COLORS: Record<CallStatus, string> = {
  new: '#8c8c8c', // grey
  queued: '#e0a53f', // yellow
  assigned: '#3f8ae0', // blue
  en_route: '#37b6d1', // light blue
  on_scene: '#f08a3e', // orange
  transporting: '#9b7ee0', // purple
  completed: '#4fbe7a', // green
  closed: '#8c8c8c',
  cancelled: '#e5484d', // red
};

/** Alarms and incidents: a red frame (TZ 15.1). */
export const ALERT_COLOR = '#e5484d';
/** Worth a look, not an emergency: a crew long on scene (yellow frame, no sound). */
export const WARN_COLOR = '#faad14';
/** A crew with nothing to do. */
export const FREE_COLOR = '#4fbe7a';
